import { withRxForm, RxFormField, RxFormFieldDef, RxFormFieldDefs, RxFormProps } from "components/rx-form";




const fields: RxFormFieldDefs = {
    SoutDatum: {
        label: 'Datum akce',
        placeholder: 'D.M.RRRR',
        validate: {
            required: {}
        }
    },
    SoutNazev: {
        label: 'Název',
        placeholder: 'název akce',
        validate: {
            required: {}
        }
    },
    SoutMisto: {
        label: 'Místo',
        placeholder: 'místo konání akce',
        validate: {
            required: {}
        }
    },
    SoutStat: {
        label: 'Stát',
        placeholder: 'stát, kde se akce konala',
        validate: {
            required: {}
        }
    },
    SoutVekKtg: {
        label: 'Věková kategorie',
        placeholder: '- vyberte -',
        validate: {
            required: {}
        }
    },
    SoutVykTrida: {
        label: 'Výkonnostní třída',
        placeholder: '- vyberte -',
        validate: {
            required: {}
        }
    },
    SoutDisciplina: {
        label: 'Disciplína',
        placeholder: '- vyberte -',
        validate: {
            required: {}
        }
    },
    SoutPocetParu: {
        label: 'Počet párů',
        placeholder: 'počet účastnících se párů',
        validate: {
            required: {},
            integer: { min: 1 }
        }
    },
    SoutPocKolektivnichClenu: {
        label: 'Počet kolektivních členů',
        placeholder: '- vyberte -',
        validate: {
            required: {}
        }
    },

    ParPocetKol: {
        label: 'Počet kol',
        placeholder: 'počet kol, kterých se pár zúčastnil',
        note: 'Upozornění:  redance se nepočítá jako kolo!',
        validate: {
            required: {},
            integer: { min: 1 }
        }
    },
    ParUmisteni: {
        label: 'Umístění páru',
        placeholder: 'pořadí, např. 1, nebo 20-23 atd.',
        validate: {
            required: {}
        }
    },
    ParVeFinale: {
        label: 'Umístění ve finále',
        placeholder: '- vyberte -',
        validate: {
            required: {}
        }
    },
    DolozeniUrlAdresa: {
        label: 'Adresa webu s výsledky',
    },
    DolozeniSoubor: {
        label: 'Soubor'
    }
}

export default fields;